Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _utils = require("../../utils");
var useStyles = exports.useStyles = function useStyles() {
  var _useWindowDimensions = (0, _utils.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  var container = {
    width: width
  };
  var styles = _reactNative.StyleSheet.create({
    container: container
  });
  return {
    styles: styles
  };
};